export default __webpack_public_path__ + "static/media/Rectangle 1484.8fc023eb.png";